import {
  ENV_BRANCH,
  ENV_DEMO,
  ENV_LOCAL,
  ENV_NEXT,
  ENV_PRODUCTION,
} from "hooks/useWhen";

export const PAYMENT_ARGS = {
  env: [ENV_LOCAL, ENV_NEXT, ENV_BRANCH, ENV_PRODUCTION, ENV_DEMO],
};
